import { AdminSettingsComponent } from '../../components';
import { connect } from 'react-redux';
import { getUsers, addUserRole, deleteUserRole, logoutUser } from '../../redux/actions/users';

const mapStateToProps = state => ({
  users: state.users.data,
  loading: state.users.loading
})

const mapDispatchToProps = {
  getUsers,
  addUserRole,
  deleteUserRole,
  logoutUser
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminSettingsComponent);



// WEBPACK FOOTER //
// ./src/containers/AdminSettings/AdminSettings.js